export { togglePasswordVisibility as togglePasswordVisibility };
export { _ as _ };
// We haven't added icon's computed property because it makes this mixin coupled with UI
const togglePasswordVisibility = {
  data() {
    return {
      passwordFieldType: 'password'
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    }
  }
};
const _ = null;

export default { togglePasswordVisibility };
